import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { testSendSettingsTemplate } from '../api/alertApi';
import { card, field, input, label, primaryButton, pre, sectionTitle } from './TemplateWizardFields';

export default function TemplateTestPanel({ templateId }) {
  const [deviceId, setDeviceId] = useState('');
  const [email, setEmail] = useState('shahsaud@enggenv.com');
  const [phone, setPhone] = useState('919897275527');
  const [sendEmail, setSendEmail] = useState(true);
  const [sendWhatsapp, setSendWhatsapp] = useState(true);
  const [result, setResult] = useState(null);

  const testMutation = useMutation({
    mutationFn: () => {
      if (!deviceId.trim()) throw new Error('Sample device ID is required');
      if (!sendEmail && !sendWhatsapp) throw new Error('Select at least one channel');
      if (sendEmail && !email.trim()) throw new Error('Email address is required to test the email channel');
      if (sendWhatsapp && !phone.trim()) throw new Error('WhatsApp number is required to test the WhatsApp channel');

      return testSendSettingsTemplate(templateId, {
        sample_device_id: deviceId.trim(),
        recipient_name: 'Test Recipient',
        email: email.trim(),
        phone_number: phone.trim(),
        send_email: sendEmail,
        send_whatsapp: sendWhatsapp,
      });
    },
    onSuccess: (data) => {
      setResult(data);
      toast.success(data.success === false ? 'Test completed with an error' : 'Test message sent');
    },
    onError: (err) => toast.error(err.message || err.response?.data?.error || 'Test send failed'),
  });

  return (
    <div style={card}>
      <div style={sectionTitle}>Test This Template</div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 14 }}>
        <label style={field}>
          <span style={label}>Sample Device ID</span>
          <input style={input} placeholder="WMSC0021" value={deviceId} onChange={(e) => setDeviceId(e.target.value)} />
        </label>
        <label style={field}>
          <span style={label}>Test Email</span>
          <input style={input} value={email} onChange={(e) => setEmail(e.target.value)} disabled={!sendEmail} />
        </label>
        <label style={field}>
          <span style={label}>Test WhatsApp Number</span>
          <input style={input} value={phone} onChange={(e) => setPhone(e.target.value)} disabled={!sendWhatsapp} />
        </label>
      </div>

      <div style={{ display: 'flex', gap: 20, marginTop: 14, flexWrap: 'wrap' }}>
        <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 14, color: '#334155', cursor: 'pointer' }}>
          <input type="checkbox" checked={sendEmail} onChange={(e) => setSendEmail(e.target.checked)} style={{ width: 16, height: 16 }} />
          Send via Email
        </label>
        <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 14, color: '#334155', cursor: 'pointer' }}>
          <input type="checkbox" checked={sendWhatsapp} onChange={(e) => setSendWhatsapp(e.target.checked)} style={{ width: 16, height: 16 }} />
          Send via WhatsApp
        </label>
      </div>

      <div style={{ marginTop: 16 }}>
        <button style={primaryButton} onClick={() => testMutation.mutate()} disabled={testMutation.isPending}>
          {testMutation.isPending ? 'Sending…' : 'Send Test'}
        </button>
      </div>

      {result && (
        <div style={{ marginTop: 18, display: 'grid', gap: 12 }}>
          <div>
            <div style={{ fontSize: 13, fontWeight: 700, color: '#334155', marginBottom: 6 }}>Rendered Email Subject</div>
            <div style={{ ...pre }}>{result.rendered?.emailSubject || '-'}</div>
          </div>
          <div>
            <div style={{ fontSize: 13, fontWeight: 700, color: '#334155', marginBottom: 6 }}>Rendered Email Body</div>
            <pre style={pre}>{result.rendered?.email || '-'}</pre>
          </div>
          <div>
            <div style={{ fontSize: 13, fontWeight: 700, color: '#334155', marginBottom: 6 }}>Rendered WhatsApp Message</div>
            <pre style={pre}>
              {result.rendered?.whatsapp?.mode === 'api_template'
                ? JSON.stringify(result.rendered.whatsapp, null, 2)
                : result.rendered?.whatsapp?.message || '-'}
            </pre>
          </div>
          {result.deliveries && (
            <div>
              <div style={{ fontSize: 13, fontWeight: 700, color: '#334155', marginBottom: 6 }}>Delivery Result</div>
              <pre style={pre}>{JSON.stringify(result.deliveries, null, 2)}</pre>
            </div>
          )}
          {result.error && (
            <div>
              <div style={{ fontSize: 13, fontWeight: 700, color: '#334155', marginBottom: 6 }}>Error</div>
              <pre style={pre}>{result.error}</pre>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
